/**
 * Beconcept - Swiper Products
 *
 */
(function () {
  "use strict";
  function initSwiperProducts(el) {
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
      breakpoints: {
        741: { slidesPerView: 3 },
        1200: { slidesPerView: 4 }
      }
    });
  }

  function initSwiperLoop(el) {
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 1.5,
      loop: true,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
      breakpoints: {
        741: { slidesPerView: 3 },
        1200: { slidesPerView: 4 }
      }
    });
  }

  function initSwiperLoopColumns(el) {
    if (el.swiper) {
      return;
    }
    var mobileSlides = parseFloat(el.dataset.slidesMobile) || 1.5;
    var desktopSlides = parseFloat(el.dataset.slidesDesktop) || 4;
    new window.Swiper(el, {
      slidesPerView: mobileSlides,
      loop: false,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
      breakpoints: {
        1024: { slidesPerView: desktopSlides }
      }
    });
  }

  function initSwiperMarquee(el) {
    if (el.swiper) {
      return;
    }
    let swipes = el.querySelectorAll('.swiper-slide').length;
    new window.Swiper(el, {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      speed: swipes * 2500,
      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
      spaceBetween: 60,
      keyboard: false,
      grabCursor: false,
      allowTouchMove: false,
      disableOnInteraction: false,
      breakpoints: {
        1024: { spaceBetween: 100, }
      }
    });
  }

  function initSwiperCategories(el) {
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 1.75,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
      breakpoints: {
        741: { slidesPerView: 4.5 },
        1200: { slidesPerView: 5.5 }
      }
    });
  }

  function initSwiperSingleLook(el) {
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 8,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
      on: {
        // Il video del look (prima slide, snippets/beconcept-look-video-slide.liquid)
        // va in pausa e torna all'inizio quando si scorre su un'altra slide,
        // così non continua (con l'audio) su una slide non visibile e
        // riparte da capo al prossimo play.
        slideChange: function (swiper) {
          swiper.slides.forEach(function (slide, index) {
            var video = slide.querySelector("[data-look-video] video");
            if (video && index !== swiper.activeIndex) {
              video.pause();
              if (video.currentTime > 0) {
                video.currentTime = 0;
              }
            }
          });
        },
      },
    });
  }

  function syncLookVideoPlayButton(video) {
    var wrapper = video.closest("[data-look-video]");
    var button = wrapper && wrapper.querySelector("[data-look-video-play]");
    if (!button) {
      return;
    }
    var playIcon = button.querySelector("[data-look-video-icon-play]");
    var pauseIcon = button.querySelector("[data-look-video-icon-pause]");
    if (playIcon) {
      playIcon.toggleAttribute("hidden", !video.paused);
    }
    if (pauseIcon) {
      pauseIcon.toggleAttribute("hidden", video.paused);
    }
    button.setAttribute("aria-label", video.paused ? button.dataset.labelPlay : button.dataset.labelPause);
  }

  function initLookVideoToggles() {
    // Stessa guardia di initColorSwatches(): evita listener duplicati con
    // l'hot-reload di "shopify theme dev".
    if (window.__lookVideoTogglesInitialized) {
      return;
    }
    window.__lookVideoTogglesInitialized = true;
    // play/pause non fanno bubbling: si ascoltano in capture, così l'icona
    // resta allineata anche quando la pausa arriva da slideChange o dal loop.
    ["play", "pause"].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (event.target.closest && event.target.closest("[data-look-video]")) {
          syncLookVideoPlayButton(event.target);
        }
      }, true);
    });
    document.addEventListener("click", function (event) {
      var playButton = event.target.closest("[data-look-video-play]");
      if (!playButton) {
        return;
      }
      event.preventDefault();
      var wrapper = playButton.closest("[data-look-video]");
      var video = wrapper && wrapper.querySelector("video");
      if (!video) {
        return;
      }
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
      }
    });
  }

  function initSwiperSingleLookRelated(el) {
    if (window.innerWidth >= 1024) {
      return;
    }
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 8,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
    });
  }

  function initSwiperReassurance(el) {
    if (window.innerWidth >= 1024) {
      return;
    }
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 1.25,
      slidesPerGroup: 1,
      spaceBetween: 10,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      navigation: {
        prevEl: el.querySelector(".be-button-prev") || el.parentElement.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next") || el.parentElement.querySelector(".be-button-next"),
      },
    });
  }

  function initSwiperRelated(el) {
    if (el.swiper) {
      return;
    }
    new window.Swiper(el, {
      slidesPerView: 1.5,
      loop: true,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      a11y: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      navigation: {
        prevEl: el.querySelector(".be-button-prev"),
        nextEl: el.querySelector(".be-button-next"),
      },
      breakpoints: {
        741: { slidesPerView: 3 },
        1200: { slidesPerView: 4 }
      }
    });
  }








  /**
   * Popup taglie della product-card (snippets/product-item.liquid, usato
   * ad es. nello swiper-singlelookrelated dei look): il bottone "Scegli"
   * apre/chiude il popup .size-choose-popup con le taglie disponibili per
   * quel colore; il click su una taglia fa un add to cart via AJAX reale
   * (endpoint nativo /cart/add.js del tema, stesso evento cart:refresh
   * usato dal resto del sito per aggiornare mini-cart/notifiche).
   */
  function isSizePopupOpen(popup) {
    return popup.style.display !== "none";
  }

  function setSizePopupOpen(popup, open) {
    popup.style.display = open ? "" : "none";
    var trigger = popup.parentElement && popup.parentElement.querySelector(".js-size-selector-trigger");
    if (trigger) {
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }
  }

  function closeAllSizeSelectors(except) {
    document.querySelectorAll(".js-size-selector-popup").forEach(function (popup) {
      if (popup !== except) {
        setSizePopupOpen(popup, false);
      }
    });
  }

  function addToCartAjax(variantId, trigger) {
    if (trigger.classList.contains("is-loading")) {
      return;
    }
    trigger.classList.add("is-loading");
    var formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    formData.append("sections", "mini-cart");
    fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      method: "POST",
      body: formData,
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        trigger.classList.remove("is-loading");
        closeAllSizeSelectors();
        if (result.ok) {
          document.dispatchEvent(new CustomEvent("variant:added", {
            bubbles: true,
            detail: { variant: result.data }
          }));
          fetch(`${window.themeVariables.routes.cartUrl}.js`).then(function (response2) {
            return response2.json();
          }).then(function (cartContent) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: { cart: cartContent }
            }));
            cartContent.sections = result.data.sections;
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: window.themeVariables.settings.cartType === "drawer"
              }
            }));
          });
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        }
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: result.ok ? "success" : "error",
            error: result.data["description"] || ""
          }
        }));
      })
      .catch(function () {
        trigger.classList.remove("is-loading");
      });
  }

  function initSizeSelectors() {
    // Guardia: con l'hot-reload di "shopify theme dev" questo script può
    // essere ri-eseguito senza un vero reload di pagina, il che
    // accumulerebbe più listener duplicati sullo stesso click (un numero
    // pari di listener fa aprire e richiudere il popup nello stesso
    // istante, apparendo come "non succede nulla").
    if (window.__sizeSelectorsInitialized) {
      return;
    }
    window.__sizeSelectorsInitialized = true;
    // capture:true (3° argomento true): il trigger e le taglie vivono
    // dentro uno .swiper-slide, e Swiper intercetta/ferma la propagazione
    // dei click nelle slide (per distinguere un tap da un drag). La fase di
    // capture (document -> ... -> target) viene eseguita PRIMA della fase
    // di bubbling in cui Swiper interviene, quindi il nostro handler vede
    // sempre il click.
    document.addEventListener("click", function (event) {
      var addToCartLink = event.target.closest(".add-to-cart-ajax[data-variant-id]");
      if (addToCartLink) {
        event.preventDefault();
        addToCartAjax(addToCartLink.getAttribute("data-variant-id"), addToCartLink);
        return;
      }
      var trigger = event.target.closest(".js-size-selector-trigger");
      if (trigger) {
        var popup = document.getElementById(trigger.getAttribute("aria-controls"));
        if (!popup) {
          return;
        }
        var willOpen = !isSizePopupOpen(popup);
        closeAllSizeSelectors(willOpen ? popup : null);
        setSizePopupOpen(popup, willOpen);
        return;
      }
      if (!event.target.closest(".js-size-selector")) {
        closeAllSizeSelectors();
      }
    }, true);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeAllSizeSelectors();
      }
    });
  }

  /**
   * Swatch colore della product-card (snippets/product-item.liquid,
   * settings.product_color_display == 'swatch'): il click su un pallino lo
   * marca come attivo e, se il colore ha un'immagine dedicata
   * (data-media-id), la mostra al posto di quella corrente; se non ne ha
   * una, torna all'immagine di default del prodotto (data-default-image).
   * Nessuna azione al passaggio del mouse.
   *
   * L'immagine di hover (.product-item__secondary-image, mostrata al
   * passaggio del mouse sulla card) può esistere in più copie: una per ogni
   * colore che ha una seconda foto taggata, più un eventuale fallback
   * generico (vedi product-item.liquid). syncSecondaryImages ne isola una
   * sola — quella taggata data-secondary-for coerente con l'immagine
   * primaria correntemente attiva — nascondendo le altre con uno style
   * inline: la regola CSS di Dawn per .product-item__secondary-image usa
   * "display: block" (per riattivarla su pointer:fine), che ha priorità
   * sull'attributo HTML "hidden", quindi qui va usato style.display, non
   * l'attributo hidden come per le immagini primarie.
   */
  function syncSecondaryImages(productItem, activeMediaId) {
    var secondaryImages = Array.from(productItem.querySelectorAll(".product-item__secondary-image[data-secondary-for]"));
    if (secondaryImages.length === 0) {
      return;
    }
    secondaryImages.forEach(function (image) {
      image.style.display = image.getAttribute("data-secondary-for") === activeMediaId ? "" : "none";
    });
  }

  function activateColorSwatch(swatchItem) {
    var list = swatchItem.closest(".color-swatch-list--card");
    if (list) {
      list.querySelectorAll(".color-swatch__item").forEach(function (item) {
        item.classList.remove("is-selected");
        item.setAttribute("aria-pressed", "false");
      });
    }
    swatchItem.classList.add("is-selected");
    swatchItem.setAttribute("aria-pressed", "true");

    var productItem = swatchItem.closest("product-item, .product-item");
    if (!productItem) {
      return;
    }
    var images = Array.from(productItem.querySelectorAll(".product-item__primary-image[data-media-id]"));
    var mediaId = swatchItem.getAttribute("data-media-id");
    var target = mediaId
      ? images.find(function (image) { return image.getAttribute("data-media-id") === mediaId; })
      : images.find(function (image) { return image.hasAttribute("data-default-image"); });
    if (!target) {
      return;
    }
    images.forEach(function (image) {
      image.hidden = image !== target;
    });
    syncSecondaryImages(productItem, target.getAttribute("data-media-id"));
  }

  // All'avvio, sincronizza l'immagine di hover con l'immagine primaria già
  // visibile lato server (quella senza "hidden"), per le card con più di
  // un'immagine hover candidata (una per colore).
  function initCardSecondaryImages(root) {
    Array.from((root || document).querySelectorAll("product-item, .product-item")).forEach(function (productItem) {
      var visiblePrimary = productItem.querySelector(".product-item__primary-image[data-media-id]:not([hidden])");
      if (!visiblePrimary) {
        return;
      }
      syncSecondaryImages(productItem, visiblePrimary.getAttribute("data-media-id"));
    });
  }

  function initColorSwatches() {
    // Stessa guardia usata per initSizeSelectors(): evita listener duplicati
    // con l'hot-reload di "shopify theme dev".
    if (window.__colorSwatchesInitialized) {
      return;
    }
    window.__colorSwatchesInitialized = true;
    initCardSecondaryImages(document);
    document.addEventListener("click", function (event) {
      var swatchItem = event.target.closest(".color-swatch-list--card .color-swatch__item");
      if (!swatchItem) {
        return;
      }
      event.preventDefault();
      activateColorSwatch(swatchItem);
    }, true);
  }

  var SWIPER_INSTANCES = [
    { selector: ".swiper-products", init: initSwiperProducts },
    { selector: ".swiper-loop", init: initSwiperLoop },
    { selector: ".swiper-loop-columns", init: initSwiperLoopColumns },
    { selector: ".swiper-marquee", init: initSwiperMarquee },
    { selector: ".swiper-categories", init: initSwiperCategories },
    { selector: ".swiper-singlelook", init: initSwiperSingleLook },
    { selector: ".swiper-singlelookrelated", init: initSwiperSingleLookRelated },
    { selector: ".swiper-related", init: initSwiperRelated },
    { selector: ".swiper-reassurance", init: initSwiperReassurance },
  ];
  function init(root) {
    SWIPER_INSTANCES.forEach(function (instance) {
      var els = (root || document).querySelectorAll(instance.selector);
      els.forEach(function (el) {
        try {
          instance.init(el);
        } catch (error) {
          console.error("[swiper-beconcept] init failed for", instance.selector, error);
        }
      });
    });
  }

  // initSizeSelectors() prima di init(document): se un carosello Swiper
  // dovesse lanciare un errore in init(), il resto dello script non deve
  // essere bloccato (altrimenti il popup taglie smetterebbe di funzionare).
  initSizeSelectors();
  initColorSwatches();
  initLookVideoToggles();
  init(document);
  // Osservatore permanente (mai disconnesso): elementi come
  // <product-recommendations> (assets/theme.js) popolano il proprio markup
  // in modo asincrono via fetch, quasi sempre DOPO DOMContentLoaded. Se
  // l'observer si stacca a DOMContentLoaded (come faceva prima), gli swiper
  // dentro contenuto inserito più tardi (es. sections/cart-recommendations.liquid)
  // non vengono mai inizializzati.
  var observer = new MutationObserver(function () {
    init(document);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.querySelector) {
      init(event.target);
      initCardSecondaryImages(event.target);
    }
  });
})();
